import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";
import RouterSessionManagement from "controllers/router-session-management/index";

/**
 * Login route
 *
 * @extends KernelRoute
 */
class FormRoute extends KernelRoute {

    onFail () {
        return window.location = "#not-found";
    }

    onSuccess (formData) {
        System.import("./preview").then(View => {
            const view = new View.default({ params: this.parsedParams, formData: formData });
            raf(_ => App.contentRegion.show(view));
        });
    }

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/preview(/)")
    route (params) {
        this.parsedParams = this.parseQueryString(params);
        let manager = new RouterSessionManagement();
        manager.obtainConfig(this.parsedParams.previewId).then(config => this.onSuccess({ presets: { configuration: config } })).catch(err => this.onFail());
    }
}

export default FormRoute;



// WEBPACK FOOTER //
// ./public/domain/views/preview/preview.route.js